import { __extends } from "tslib";
import { IgrAssigningCategoryStyleEventArgsBase } from "./igr-assigning-category-style-event-args-base";
import { AssigningCategoryMarkerStyleEventArgs as AssigningCategoryMarkerStyleEventArgs_internal } from "./AssigningCategoryMarkerStyleEventArgs";
/**
 * Represents event arguments class for the AssigningCategoryStyleEvent
*
* The `assigningCategoryMarkerStyle` event fired to allow you to override the style of markers for the items in a category or financial series.
*
* ```ts
* <IgrDataChart
*     dataSource={this.state.dataSource}
*     width="700px"
*     height="500px">
*
*     <IgrCategoryXAxis name="xAxis" label="Year" />
*     <IgrNumericYAxis  name="yAxis" />
*
*     <IgrRangeColumnSeries
*         name="series1"
*         xAxisName="xAxis"
*         yAxisName="yAxis"
*         highMemberPath="High"
*         lowMemberPath="Low"
* 		isCustomCategoryStyleAllowed="true"
* 		assigningCategoryMarkerStyle= {this.onAssigningCategoryMarkerStyle} />
*  </IgrDataChart>
* ```
*
* ```ts
* series1.assigningCategoryMarkerStyle= this.onAssigningCategoryMarkerStyle ;
* public onAssigningCategoryMarkerStyle =( s:IgrCategorySeries, e: AssigningCategoryStyleEventArgs) => {
*
* }
* ```
*/
var IgrAssigningCategoryMarkerStyleEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrAssigningCategoryMarkerStyleEventArgs, _super);
    function IgrAssigningCategoryMarkerStyleEventArgs() {
        return _super.call(this) || this;
    }
    IgrAssigningCategoryMarkerStyleEventArgs.prototype.createImplementation = function () {
        return new AssigningCategoryMarkerStyleEventArgs_internal();
    };
    Object.defineProperty(IgrAssigningCategoryMarkerStyleEventArgs.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    return IgrAssigningCategoryMarkerStyleEventArgs;
}(IgrAssigningCategoryStyleEventArgsBase));
export { IgrAssigningCategoryMarkerStyleEventArgs };
